import { WorkspaceEntryReadModel } from "@Organizations/Workspaces/Domain/readmodels";

export class ProjectWorkspaceSwitcherViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    readonly workspaceId: number;
    projectId: number | null = null;
    projectName: string | null = null;
    newWorkspaceId: number | null = null;

    workspaces: WorkspaceEntryReadModel[] = [];

    constructor(workspaceId: number)
    {
        this.workspaceId = workspaceId;
    }

    show(projectId: number, projectName: string)
    {
        this.projectId = projectId;
        this.projectName = projectName;
        this.newWorkspaceId = this.workspaceId;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.projectId = null;
        this.projectName = null;
        this.newWorkspaceId = null;
    }

    setData(workspaces: WorkspaceEntryReadModel[])
    {
        this.workspaces = workspaces;

        this.initialized = true;
    }
}

